import { TimerType } from '@Core/enums/timer-type.enum';
import { TaskTimer } from '@Core/utils/task-utils';
import { TimeInStrPipe, TimeMaxUnitEnum } from '@Shared/Pipes/time.pipe';
import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef, SimpleChanges } from '@angular/core';

@Component({
    standalone: false,
    selector: 'task-timer',
    templateUrl: './task-timer.component.html',
    styleUrls: ['./task-timer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TaskTimerComponent {
    @Input() dueOn: Date;
    @Input() background: 'dark' | 'light';
    @Input() timerType: TimerType;
    @Input() taskName: string = null;
    @Input() state: 'bar' | 'badge' | 'standalone' = 'standalone';
    @Input() includeTimeInfo: boolean = true;
    @Input() taskTimer: TaskTimer = null;

    @Output() timerClicked: EventEmitter<string> = new EventEmitter();

    public timerStyle: string;

    public timerState: TimerState;

    public timerPipe = new TimeInStrPipe();


    constructor(private cdr: ChangeDetectorRef) { }

    public ngOnInit(): void {
        this.isDueSoonOrPastDueSetup();
    }

    public ngOnChanges(changes: SimpleChanges) {
        if (changes.dueOn?.currentValue != changes.dueOn?.previousValue) {
            this.isDueSoonOrPastDueSetup();
        }
    }

    public resetTimer() {
        // Set the time information the first time
        this.isDueSoonOrPastDueSetup();
    }

    isDueSoonOrPastDueSetup() {       
        if (!this.dueOn)
            return;

        if (this.taskTimer?.Imminence)
            this.timerState = this.taskTimer.Imminence.toLowerCase() as TimerState;
        else
          this.timerState = this.getImminence();

        this.cdr.detectChanges();
    }

    // Old method for compatibility, can be removed later
    getImminence(): TimerState {
        const remainingTime = new Date(this.dueOn).getTime() - new Date().getTime();
        const oneDay = 1000 * 60 * 60 * 24;
        const deadlineImminent = oneDay * 5; // 5 days 
        const serviceLevelImminent = oneDay * 2; // 2 days
        const dueDateImminent = oneDay;

        if (remainingTime < 0) {
            return TimerState.late;
        } else if ((this.timerType == TimerType.Deadline && remainingTime < deadlineImminent)
            || (this.timerType == TimerType.SLA && remainingTime < serviceLevelImminent)
            || (this.timerType == TimerType.DueDate && remainingTime < dueDateImminent)
            || (!this.timerType && remainingTime < serviceLevelImminent)) {
            return TimerState.imminent;
        } else {
            return TimerState.pending;
        }
    }

    public getTooltip(): string {
        if (!this.dueOn) 
            return '';

        var timerType = this.timerType ?? this.taskTimer?.Type;

        var tooltip: string = timerType;
        if (timerType == 'SLA') {
            tooltip = 'Service Level';
        }

        var now = (new Date()).getTime();

        if (this.timerState == TimerState.pending) {
            let timeLeft = this.dueOn.getTime() - now;
            let text = this.timerPipe.transform(timeLeft, true, false, TimeMaxUnitEnum.Week);

            tooltip += ' is due in ' + text + '.';

            var imminentTimeLeft: number;
            if (this.taskTimer?.ImminentDate) {
                var immimentDate = this.taskTimer.ImminentDate.getTime();
                imminentTimeLeft = immimentDate - now;
            } else {
                const oneDay = 1000 * 60 * 60 * 24;
                const deadlineImminent = oneDay * 5; // 5 days 
                const serviceLevelImminent = oneDay * 2; // 2 days
                const dueDateImminent = oneDay;
                if (timerType == TimerType.Deadline) {
                    immimentDate = this.dueOn.getTime() - deadlineImminent;
                } else if (timerType == TimerType.SLA) {
                    immimentDate = this.dueOn.getTime() - serviceLevelImminent;
                } else {
                    immimentDate = this.dueOn.getTime() - dueDateImminent;
                } 
                imminentTimeLeft = immimentDate - now;
            }

            let immText = this.timerPipe.transform(imminentTimeLeft, true, false, TimeMaxUnitEnum.Week);
            tooltip += ' This will become imminent in ' + immText + '.';


        } else if (this.timerState == TimerState.imminent) {
            let timeLeft = this.dueOn.getTime() - now;
            let text = this.timerPipe.transform(timeLeft, true, false, TimeMaxUnitEnum.Week);
            tooltip += ' is due in ' + text + '.';

        } else {
            let timePast = now - this.dueOn.getTime();
            let text = this.timerPipe.transform(timePast, true, false, TimeMaxUnitEnum.Week);
            tooltip += ' is ' + text +  ' past due.';
        }

        return tooltip;
    }
}

export enum TimerState {
    'pending' = 'pending',
    'imminent' = 'imminent',
    'late' = 'late'
};